import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { useAppSelector } from './useAppSelector';
import { getFamilyMembersSchema } from 'Modules/Requests/UpdatePersonalDetails/Schema';
import { useLayoutEffect, useState } from 'react';

export const useFamilyMembersForm = () => {
  const [isDirty, setIsDirty] = useState(false);

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const familyMembersForm = useForm<{
    familyMembers: IUpdatePersonalDetails['familyMembers'];
  }>({
    mode: 'all',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(getFamilyMembersSchema(isDirty) as any),
    defaultValues: {
      familyMembers: [
        {
          gender: generalOptions?.general?.genders?.[0]?.id || 0,
          birthDate: null,
        },
      ],
    },
  });

  useLayoutEffect(() => {
    setIsDirty(familyMembersForm.formState.isDirty);
  }, [familyMembersForm.formState.isDirty]);

  return familyMembersForm;
};
